import { useDomain } from "../../../Models/Domain/Domain.Context";

/**
 * Domain selector — injected into the NavBar's right section by AIStudioView
 * (replacing the default right-side widgets while on AI Studio pages).
 * AI Studio is super-admin-only (Chuck 2026-04-24), so no per-user gating.
 */
export function DomainPicker(): React.ReactElement {
  const { activeDomain, allManifests, setActiveDomain } = useDomain();

  return (
    <label className="DomainPicker flex items-center gap-2 text-sm">
      <span className="text-grey-400">Domain</span>
      <select
        className="rounded-md border border-grey-200 bg-white px-2 py-1 text-grey-900"
        value={activeDomain}
        onChange={(e) => setActiveDomain(e.target.value as typeof activeDomain)}
      >
        {allManifests.map((manifest) => (
          <option key={manifest.id} value={manifest.id}>
            {manifest.displayName}
          </option>
        ))}
      </select>
    </label>
  );
}
